<template>
  <div>
    <b-form-select
        v-model="selectedIndex"
        @change="onSelectionChanged"
        :disabled="internalValues.length == 0"
        class="form-control"
    >
      <option v-for="(item, index) in internalValues" :key="item.Id" :value="index">
        {{ item.Name }}
      </option>
    </b-form-select>

  </div>
</template>

<script>
import service                  from '@/services/HttpRequestService';
import ObjSpinnerState          from "@/components/common/spinner/ObjSpinnerState";
import formatter                from '@/utilities/Formatter';
import ObjParameterValueStorage from "@/components/common/parameterValuePicker/ObjParameterValueStorage";
import ObjAlertState            from "@/components/common/alert/ObjAlertState";

export default {
  props: {
    value:          '',
    subType:        '',
    modeRestricted: {
      type:    Boolean,
      default: false
    }
  },
  data() {
    return {
      internalValues: [],
      selectedIndex:  -1,
      ObjSpinnerState
    }
  },
  async created() {
    //if (this.modeRestricted) {return null}
    await this.defineSelfState();
  },
  watch:      {
    async subType() {
      await this.defineSelfState();
    }
  },
  methods:    {
    async defineSelfState() {
      this.internalValues = await this.loadData();
      const savedSelectionIdx = this.loadSelection();
      const proposedSelectionIdx = (savedSelectionIdx !== -1) ? savedSelectionIdx :
       this.internalValues.findIndex((value, idx) => {
        return (value.Id === this.value);
      });
      if (-1 !== proposedSelectionIdx && proposedSelectionIdx < this.internalValues.length) {
          this.selectedIndex = proposedSelectionIdx;
      } else if (this.internalValues.length > 0) {
        this.selectedIndex = 0;
      } else {
        this.selectedIndex = -1;
      }
      this.onSelectionChanged(this.selectedIndex);
    },
    onSelectionChanged(newIndex) {
      this.saveSelection();
      if (this.internalValues && this.internalValues.length > 0) {
        this.$emit('valueChanged', this.internalValues[newIndex].Id)
      }
    },
    async loadData() {
      try {
        this.ObjSpinnerState.isOn = true;
        if (this.subType === 'calculations') {
          const apiResponse = await service.getCalculations();
          return (apiResponse.data || [])
            .filter((calculation) => {
              return (calculation && calculation.PortfolioName && calculation.SettlementDate);
            })
            .map(calculation => {
              const dateFormatted = formatter.formatDateString(calculation.SettlementDate, "MM/DD/YYYY");
              calculation.Name = `${calculation.PortfolioName} ${dateFormatted}${calculation.EarlyCall ? ' EarlyCall' : ''}`;
              return calculation;
            });
        } else if (this.subType === 'deals') {
          const apiResponse = await service.getUserDealsNames();
          return (apiResponse.data || [])
            .map(deal => {
              return {
                Id: deal, Name: deal
              };
            });
        }
      } catch (apiError) {
        return [];
      } finally {
        this.ObjSpinnerState.isOn = false;
      }
    },
    saveSelection() {
      if (this.subType === 'calculations') {
        ObjParameterValueStorage.set('select_calculations', this.selectedIndex);
      }
    },
    loadSelection() {
      if (this.subType !== 'calculations') {
        return -1;
      }
      try {
        const selectionIdx = +ObjParameterValueStorage.get('select_calculations');
        return isNaN(selectionIdx) ? -1 : selectionIdx;
      } catch (e) {
      }
      return -1;
    }
  },
  components: {}
}
</script>

<style>
</style>
